
export default function CarouselCard10() {

    return (
        <div
            className="swiper-slide content-slide"
            data-title="High School">
            <div
                className="row align-items-start align-items-lg-center">
                <div
                    className="col-6 col-lg-auto position-relative d-flex flex-wrap gap-3">
                    <img
                        className="polaroid img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2Fc09fc6cc86918abd0205a9a469887a18.webp?alt=media&token=a4a0514f-b474-4eff-91b1-ff08e7db8230"
                        alt="Academics Overview Image #1"/>

                    <img
                        className="polaroid img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2FDSC01628.webp?alt=media&token=a993df57-ba5b-4ec0-9c52-7d988d5ec13e"
                        alt="High School Academy"/>
                </div>
                <div className="col-6 col-lg">
                    <h5 className="text-3xl"> Mindset Shift by Deployment Day </h5>
                    <p className="mt-2"><span
                        style={{whiteSpace: 'pre-wrap'}}>
                        Extern Academy is designed to show you that a human is capable of much more than you know. It opens your mind to the true possibilities of your potential. With that comes a noticeable change in your thinking process. You no longer fear tough challenges or solving complex problems all day. You realize that no matter what the world throws at you, you will win.
                    </span>
                    </p>
                </div>
            </div>
        </div>
    )
}